import { useNavigate } from "react-router-dom";
import withLoader from "../../components/layouts/WithLoader";
import TextField from "@mui/material/TextField"; // Ensure you import TextField from MUI
import React, { useState } from "react";
import DataTableTransfertsEntreCompte from "../../ui/DataTableTransfertsEntreCompte";
import SellingService from "../../services/SellingService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
const TransfertEntreComptes = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();

  // States for date fields
  const [dateBegin, setDateBegin] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [data, setData] = useState([]);


  // Handlers for date changes
  const onChangeDateBegin = (event) => {
    setDateBegin(event.target.value);
  };

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value);
  };


  const onGetJournauxByFiltersHandler = () => {
    const formatDateTime = (date, isEndOfDay = false) => {
      const dateObj = new Date(date);
      const year = dateObj.getFullYear();
      const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      const day = dateObj.getDate().toString().padStart(2, '0');
      const hours = isEndOfDay ? '23' : '00';
      const minutes = isEndOfDay ? '59' : '00';
      const seconds = isEndOfDay ? '59' : '00';

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    };
    const formattedDateBegin = formatDateTime(dateBegin);
    const formattedDateEnd = formatDateTime(dateEnd, true);

    // console.log("Filter applied", { dateBegin: formattedDateBegin, dateEnd: formattedDateEnd });
    startLoading();
    SellingService.payementsTransferts(getCurrentUserId(), formattedDateBegin, formattedDateEnd)
      .then(response => {
        // console.log(response);
        setData(response.data.success)
        stopLoading();
      })
      .catch(error => {
        console.error("Error fetching payments and transfers:", error);
      });
  };




  // Navigate function
  const navigateToAddTransfertAccounts = () => {
    navigate("/addTransfertsEntreCompte");
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div className="card mt-3">
                <div className="card-body">
                  <h5 className="card-title">Ajouter un transfert</h5>

                  <button
                    className="btn btn-dark float-right"
                    onClick={navigateToAddTransfertAccounts}
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              <section className="content">
                <div className="container-fluid">
                  <div className="row mb-2">
                    <div className="col-sm-12">
                      <div className="card card-dark">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label htmlFor="inputName">Date début</label>
                                <TextField
                                  style={{ width: "100%" }}
                                  className="col-sm-12"
                                  variant="outlined"
                                  value={dateBegin}
                                  onChange={onChangeDateBegin}
                                  id="date"
                                  type="date"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  size="small"
                                />
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label htmlFor="inputName">Date fin</label>
                                <TextField
                                  style={{ width: "100%" }}
                                  className="col-sm-12"
                                  variant="outlined"
                                  value={dateEnd}
                                  onChange={onChangeDateEnd}
                                  id="date"
                                  type="date"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  size="small"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card-footer">
                          <div className="row">
                            {/*dateBegin || dateEnd ? (
                              <div className="col-sm-6 text-center">
                                <button
                                  className="btn btn-dark"
                                  onClick={onClearGetJournauxByFiltersHandler}
                                >
                                  Annuler Filter
                                </button>
                              </div>
                            ) : null*/}
                            <div
                              className={
                                "col-sm-12 text-center"
                              }
                            >
                              <button
                                className="btn btn-dark"
                                onClick={onGetJournauxByFiltersHandler}
                              >
                                Valider le choix
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <DataTableTransfertsEntreCompte data={data} title={"Transferts Entre Comptes"} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withLoader(TransfertEntreComptes);
